import { useMemo } from 'react';

export const useColumns = () =>
  useMemo(() => {
    return [
      {
        field: 'name',
        headerName: 'Name',
      },
      {
        field: 'startDate',
        headerName: 'Start date',
      },
      {
        field: 'endDate',
        headerName: 'End date',
      },
      {
        field: 'empNumber',
        headerName: 'Employee ID',
      },
      {
        field: 'jobCode',
        headerName: 'Job Class Code',
      },
      {
        field: 'payCode',
        headerName: 'Pay Code',
      },
      {
        field: 'hours',
        headerName: 'Hours',
      },
      
    ];
  }, []);
